import React, { Component, Fragment } from 'react';
import { Button, Input, Label, FormGroup, InputGroup, InputGroupAddon } from 'reactstrap';
import autobind from 'autobind-decorator';

import Select from 'react-select';
import Loading from 'apa/components/Loading';
import { connect } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next'
import { Money } from 'items/ItemList';
import DateFormatter from 'apa/components/Date';
import * as invoices from 'invoices/actions/invoices';
import { getURL } from 'apa/actions/generic'

export function formatDate(date) {
    const year = date.getFullYear();
    const _month = '' + (date.getMonth() + 1);
    const _day = '' + date.getDate();

    const month = _month.length < 2 ? '0' + _month : _month;
    const day = _day.length < 2 ? '0' + _day : _day;

    return [year, month, day].join('-');
}

export function getStartOfLastMonth() {
    const today = new Date();
    today.setDate(1);
    today.setMonth(today.getMonth() - 1);
    return formatDate(today);
}

export function getEndOfLastMonth() {
    const today = new Date();
    today.setDate(0);
    return formatDate(today);
}

export function getToday() {
    const today = new Date();
    return formatDate(today);
}

/*
const InvoiceSchema = yup.object().shape(
    {
        customer: yup.number().required(),
        rechnungdatum: yup.date().required(),
        due_date: yup.date().required()
    }
);
*/

@connect(
    state => (
        {
            auth: state.apa
        }
    ),
    dispatch => (
        {
            fetchInvoices: () => dispatch(invoices.fetchInvoices())
        }
    )
)
export default class InvoiceDetail extends Component {

    constructor(props) {
        super(props);
        const id = this.props.match.params.id;
        const customer_id = this.props.match.params.customer_id;
        if (id) {
            this.state = {
                invoice_type: 0,
                isNew: false,
                isLoading: true,
                customers: null,
                customerOption: '',
                invoice: null,
                locations: [],
                includeLocations: true,
            }
        } else {
            this.state = {
                isNew: true,
                includeLocations: true,
                isLoading: true,
                customers: null,
                locations: [],
                invoice: {
                    invoice_type: 0,
                    number_of_intervals: 1,
                    invoice_nr: '',
                    customer: customer_id,
                    invoice_date: formatDate(new Date()),
                    due_date: formatDate(new Date()),
                    time_sheets: [],
                    work_logs: [],
                    pre_tax: 0,
                    tax_amount: 0,
                    after_tax: 0,
                    start: getStartOfLastMonth(),
                    end: getEndOfLastMonth(),
                    year: (new Date()).getFullYear() - 1,
                    selectedLocations: []
                },
                hourlyrate: null,
            }
        }
    }

    componentDidMount() {
        const headers = { 'Content-Type': 'application/json' };
        headers['Authorization'] = `Token ${this.props.auth.token}`;
        const customer_id = this.props.match.params.customer_id;
        if (this.state.isNew) {
            if (customer_id) {
                fetch(
                    `/api/customers/${customer_id}/`,
                    { headers }
                )
                    .then(res => res.json())
                    .then(customer => {
                        this.setState(
                            {
                                isLoading: false,
                                locations: customer.locations,
                                invoice: {
                                    ...this.state.invoice,
                                    customer: {
                                        id: customer.id,
                                        name: customer.name
                                    },
                                }
                            }
                        )
                    }
                    )

            } else {
                fetch(
                    '/api/customers/active/',
                    { headers }
                ).then(res => res.json())
                    .then(
                        customers =>
                            this.setState(
                                {
                                    isLoading: false,
                                    customers: customers
                                }
                            )
                    )
            }
        } else {
            fetch(
                `/api/invoices/${this.props.match.params.id}/`,
                { headers }
            ).then(res => res.json())
                .then(
                    invoice =>
                        this.setState(
                            {
                                isLoading: false,
                                invoice: invoice
                            }
                        )
                )

        }
    }

    @autobind
    search() {
        const { start, end, customer, invoice_type, number_of_intervals, selectedLocations } = this.state.invoice;
        let parameters = {
            invoice_type: invoice_type,
            customer: customer.id || customer.value || customer,
            start: start,
            selectedLocations: selectedLocations
        }
        if (invoice_type == 0) {
            parameters = {
                ...parameters,
                end: end
            }
        }
        if (invoice_type > 0) {
            parameters = {
                ...parameters,
                number_of_intervals: number_of_intervals
            }
        }
        const headers = { };
        headers['Authorization'] = `Token ${this.props.auth.token}`;
        fetch(
            getURL('/api/invoices/preview/', parameters),
            {headers}
        ).then(res => res.json()).then(
            res => {
                this.setState(
                    {
                        invoice: {
                            ...this.state.invoice,
                            ...res
                        },
                    }
                )
            }
        )
    }

    @autobind
    validate(values) {
        let errors = {};
        if (!values.customer)
            errors.customer = 'Required';
        if (!values.invoice_date)
            errors.invoice_date = 'Required';
        if (!values.due_date)
            errors.due_date = 'Required';
        return errors
    }

    @autobind
    onSubmit() {
        const headers = { 'Content-Type': 'application/json' };
        headers['Authorization'] = `Token ${this.props.auth.token}`;
        const invoice = { ...this.state.invoice };
        const body = JSON.stringify(invoice);
        if (this.state.isNew) {
            fetch(
                '/api/invoices/',
                { headers, method: 'POST', body }
            ).then(() => {
                this.props.fetchInvoices();
                this.props.history.push('/invoices')
            }
            )
        } else {
            fetch(
                `/api/invoices/${this.state.invoice.id}`,
                { headers, method: 'POST', body }
            ).then(
                () => {
                    this.props.fetchInvoices();
                    this.props.history.push('/invoices')
                }
            )

        }
    }

    @autobind
    markPaid() {
        const invoice_id = this.state.invoice.id;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Token ${this.props.auth.token}`
        };
        const body = JSON.stringify({
            paid_at: this.state.paid_at
        });
        fetch(
            `/api/invoices/${invoice_id}/paid/`,
            { headers, method: 'POST', body }
        ).then(
            res => res.json()
        ).then(
            invoice => {
                this.setState({
                    invoice: invoice
                });
                this.props.fetchInvoices();
                this.props.history.push('/invoices')
            }
        )
    }

    @autobind
    selectCustomer(customerOption) {
        this.setState(
            {
                customerOption: customerOption,
                invoice: { ...this.state.invoice, customer: customerOption.value }
            }
        );
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`,
            'Content-Type': 'application/json'
        };
        fetch(
            `/api/customers/${customerOption.value}/invoice_settings/`,
            { headers }
        ).then(
            res => res.json()
        ).then(
            res => {
                const locations = res.locations;
                const start = new Date(res.last_payment);
                const end = new Date(res.last_payment);
                end.setMonth(end.getMonth() + res.payment_interval_type);
                this.setState({
                    locations: locations,
                    invoice: {
                        ...this.state.invoice,
                        start: formatDate(start),
                        end: formatDate(end)
                    }
                })
                this.search();
            }
        )
    }

    render() {
        if (this.state.isLoading)
            return <Loading />;
        const customers = this.state.customers;
        /*
        const timesheetsColumns = [
            {
                dataField: 'date',
                text: 'Datum',
                formatter: cell => <DateFormatter date={cell}/>
            },
            {
                dataField: 'hours',
                text: 'Stunden'
            },
            {
                dataField: 'comment',
                text: 'Bezeichnung'
            },
            {
                dataField: 'id',
                text: 'Preis',
                formatter: (cell, row) => Money(row.hours * this.state.hourlyrate)
            }
        ];
        */
        const worklogColumns = [
            {
                dataField: 'date',
                text: 'Datum',
                formatter: cell => <DateFormatter date={cell} />
            },
            {
                dataField: 'comment',
                text: 'Bezeichnung'
            },
            {
                dataField: 'hours',
                text: 'Stunden'
            },
            {
                dataField: 'price',
                text: 'Preis',
                formatter: cell => Money(cell)
            },
        ];
        return <Fragment>
            <FormGroup>
                {
                    this.state.isNew &&
                    <Fragment>

                        {
                            this.state.customers &&
                            <Fragment>
                                <Label>
                                    Kunde
                                </Label>
                                <Select
                                    value={this.state.customerOption}
                                    onChange={
                                        customerOption => this.selectCustomer(customerOption)
                                    }
                                    options={
                                        customers.map(
                                            customer => ({ value: customer.id, label: customer.name })
                                        )}
                                />
                            </Fragment>
                        }
                        {!this.state.customers &&
                            <h1>{this.state.invoice.customer.name}</h1>

                        }
                        <ul className='p-2'>
                            {
                                this.state.locations.map(
                                    location =>
                                        <li key={`location_id_${location.id}`}>
                                            <Input type='checkbox' checked={this.state.includeLocations[location.id]}
                                                onChange={
                                                    e => {
                                                        const checked = e.target.checked;
                                                        var locations = this.state.invoice.selectedLocations;
                                                        if(checked) {
                                                            locations.push(location.id);
                                                        } else {
                                                            locations = locations.filter(
                                                                loc => loc != location.id
                                                            )
                                                        }
                                                        const invoice = {...this.state.invoice, selectedLocations: locations}
                                                        this.setState({ invoice: invoice})
                                                    }
                                                } />
                                            {location.name}
                                        </li>
                                )
                            }
                        </ul>
                    </Fragment>
                }
                {!this.state.isNew &&
                    <Fragment>
                        <h1>{this.state.invoice.customer.name}</h1>
                        <h2>{this.state.invoice.invoice_nr}</h2>
                        {!this.state.invoice.status &&
                            <Fragment>
                                <Label>
                                    Bezahlt am
                        </Label>
                                <InputGroup>
                                    <Input type={'date'} value={this.state.paid_at}
                                        onChange={e => this.setState({ paid_at: e.target.value })} />
                                    <InputGroupAddon addonType={'append'}>
                                        <Button color={'success'} onClick={this.markPaid}
                                            disabled={!this.state.paid_at}
                                        >
                                            Als bezahlt markieren
														</Button>
                                    </InputGroupAddon>
                                </InputGroup>
                            </Fragment>
                        }
                    </Fragment>
                }
            </FormGroup>
            <FormGroup>
                <Label>
                    Rechungsdatum
                </Label>
                <Input name='invoice_date' type='date' label="Rechnungsdatum"
                    value={this.state.invoice.invoice_date}
                    disabled={!this.state.isNew}
                    onChange={e => this.setState({
                        invoice: {
                            ...this.state.invoice,
                            invoice_date: e.target.value
                        }
                    })} />
            </FormGroup>
            <FormGroup>
                <Label>
                    Fälligkeitsdatum
                </Label>
                <Input name='due_date' type='date' label="Fälligkeitsdatum"
                    disabled={!this.state.isNew}
                    value={this.state.invoice.due_date}
                    onChange={e => this.setState({
                        invoice: {
                            ...this.state.invoice,
                            due_date: e.target.value
                        }
                    })} />
            </FormGroup>
            <FormGroup>
                <Label>
                    Rechnungsart
								</Label>
                <Input type='select' onChange={e => this.setState({
                    invoice: {
                        ...this.state.invoice,
                        invoice_type: e.target.value
                    }
                })}
                    value={this.state.invoice.invoice_type}
                >
                    <option value={0}>
                        Einfach
                    </option>
                    <option value={1}>
                        Interval
                    </option>
                    <option value={2}>
                        Interval mit Zusatzleistungen
                    </option>
                    <option value={3}>
                        Jahresabrechnung
                    </option>
                </Input>
            </FormGroup>
            {this.state.invoice.invoice_type == 0 &&
                <FormGroup>
                    <Label>
                        Leistungszeitraum
                </Label>
                    <InputGroup>
                        <Input type='date' value={this.state.invoice.start}
                            disabled={!this.state.isNew}
                            onChange={e => this.setState({ invoice: { ...this.state.invoice, start: e.target.value } })} />
                        <Input type='date' value={this.state.invoice.end}
                            disabled={!this.state.isNew}
                            onChange={e => this.setState({ invoice: { ...this.state.invoice, end: e.target.value } })} />
                        {
                            this.state.isNew &&
                            <InputGroupAddon addonType={'append'}>
                                <Button color={'primary'} onClick={this.search}>
                                    Aktualisieren
											</Button>
                            </InputGroupAddon>
                        }
                    </InputGroup>
                </FormGroup>
            }
            {this.state.invoice.invoice_type == 1 || this.state.invoice.invoice_type == 2 &&
                <FormGroup>
                    <Label>
                        Interval
                </Label>
                    <InputGroup>
                        <Input type='date' value={this.state.invoice.start}
                            disabled={!this.state.isNew}
                            onChange={e => this.setState({ invoice: { ...this.state.invoice, start: e.target.value } })} />
                        <Input
                            type='number'
                            value={this.state.invoice.number_of_intervals}
                            disabled={!this.state.isNew}
                            placeholder="Anzahl der Intervalle"
                            min={1}
                            onChange={
                                e => this.setState({ invoice: { ...this.state.invoice, number_of_intervals: e.target.value } })
                            }
                        />
                        {
                            this.state.isNew &&
                            <InputGroupAddon addonType={'append'}>
                                <Button color={'primary'} onClick={this.search}>
                                    Aktualisieren
											</Button>
                            </InputGroupAddon>
                        }
                    </InputGroup>
                </FormGroup>
            }
            {this.state.invoice.invoice_type == 3 &&
                <FormGroup>
                    <Label>
                        Jahr
                </Label>
                    <InputGroup>
                        <Input type='year' value={this.state.invoice.year}
                            disabled={!this.state.isNew}
                            onChange={e => this.setState({ invoice: { ...this.state.invoice, year: e.target.value } })} />
                        {
                            this.state.isNew &&
                            <InputGroupAddon addonType={'append'}>
                                <Button color={'primary'} onClick={this.search}>
                                    Aktualisieren
                                            </Button>
                            </InputGroupAddon>
                        }
                    </InputGroup>
                </FormGroup>
            }
            {
                this.state.isNew &&
                <FormGroup>
                    <Label>
                        Rechnungsnummer
                    </Label>
                    <Input type='text' value={this.state.invoice.invoice_nr}
                        pattern="^1.[0-9]{4}$"
                        onChange={e => this.setState({
                            invoice: {
                                ...this.state.invoice,
                                invoice_nr: e.target.value
                            }
                        })} />
                </FormGroup>
            }
            <Fragment>
                {this.state.invoice.invoice_type != 1 &&
                    <BootstrapTable
                        bootstrap4
                        striped
                        keyField={'id'}
                        data={
                            [
                                ...this.state.invoice.time_sheets,
                                ...this.state.invoice.work_logs
                            ]
                        } columns={worklogColumns}
                    />
                }
                <FormGroup>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    Grundbetreuung:
												</td>
                                <td>
                                    {Money(this.state.invoice.regular_pre_tax)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Zusatzstunden:
												</td>
                                <td>
                                    {this.state.invoice.extra_hours}h a {Money(this.state.invoice.hourly_rate)}/h {Money(this.state.invoice.extra_hours_pre_tax)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Zusatzleistungen:
												</td>
                                <td>
                                    {Money(this.state.invoice.work_log_pre_tax)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Brutto:
												</td>
                                <td>
                                    {Money(this.state.invoice.pre_tax)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    MwSt:
												</td>
                                <td>
                                    {Money(this.state.invoice.tax_amount)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Netto:
												</td>
                                <td>
                                    {Money(this.state.invoice.after_tax)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </FormGroup>
            </Fragment>
            {this.state.isNew &&
                <Fragment>
                    {this.state.invoice.extra_hours < 0 &&
                        <div className="alert alert-warning" role="alert">
                            {this.state.invoice.extra_hours} Stunden Differenz!
								</div>
                    }
                    <Button color='primary' type={'submit'} disabled={this.state.isSubmitting}
                        onClick={this.onSubmit}>
                        Speichern
            </Button>
                </Fragment>
            }
        </Fragment>

    }
}
